import React from 'react';
import {Row, Col, Button, Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import Card from "../../../Card";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import cookie from "react-cookies";

class DuelingConfigure extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            useDistance: false,
            distance: 5,
            distanceToProjector: 0,
            heightOfTargetArea: 0,
        }

        const config = cookie.load("scaleConfig")
        if (!!config) {
            this.state = {...this.state, ...config}
        }
    }

    saveSettings() {
        if (this.state.useDistance) {
            let config = {
                distanceToProjector: this.state.distanceToProjector,
                heightOfTargetArea: this.state.heightOfTargetArea
            }
            cookie.save("scaleConfig", config)
        }
        this.props.saveSettings(this.state)
    }

    render() {
        return (
            <>
                <Row>
                    <Col sm={12} md={{span: 8, offset: 2}}>
                        <Card>
                            <h5 style={{textDecoration: "underline"}}>설정</h5>
                            <Form inline>
                                <Form.Check
                                    type="switch"
                                    label="거리에 따른 표적 크기"
                                    id="custom-switch"
                                    checked={this.state.useDistance}
                                    onChange={(e) => {this.setState({useDistance: e.target.checked})}}
                                    inline
                                    style={{marginRight: "2px"}}
                                />

                                <OverlayTrigger
                                    placement={"bottom"}
                                    overlay={
                                        <Tooltip id={`info-tooltip`}>
                                            이 옵션을 선택하면 Take Aim이 특정 거리에 있는 것처럼 표적을 표시할 수 있습니다. 투사된 표적 영역의 높이와 프로젝터까지의 거리를 사용하여 Take Aim은 표적을 표시할 크기를 계산할 수 있습니다.
                                        </Tooltip>
                                    }
                                >
                                    <FontAwesomeIcon icon={faInfoCircle} style={{marginRight: "1rem"}}/>
                                </OverlayTrigger>
                            </Form>
                            {this.state.useDistance &&
                            <>
                                <hr  style={{borderTop: "1px solid white"}}/>
                                <Form.Group style={{marginTop: "0px", marginBottom: 0}}>
                                    <Form.Label>표적으로부터의 거리 (단위: 야드)</Form.Label>
                                    <Form.Control value={this.state.distance} onChange={(e) => {this.setState({distance: e.target.value})}} type={"number"} />
                                </Form.Group>
                                <hr  style={{borderTop: "1px solid white"}}/>
                                <p style={{marginBottom: 0}}>표적 크기를 정확하게 표현하기 위해 필요한 측정값은 다음과 같습니다:</p>
                                <Form.Group>
                                    <Form.Label>화면과의 거리 (단위: 인치)</Form.Label>
                                    <Form.Control  value={this.state.distanceToProjector} onChange={(e) => {this.setState({distanceToProjector: e.target.value})}} type={"number"}/>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>표적 영역의 높이 (단위: 인치)</Form.Label>
                                    <Form.Control  value={this.state.heightOfTargetArea}
                                                   onChange={(e) => {this.setState({heightOfTargetArea: e.target.value})}}
                                                   type={"number"}/>
                                </Form.Group>
                            </>
                            }
                        </Card>
                    </Col>
                </Row>
                <Row style={{marginTop: "20px"}}>
                    <Col sm={12} className={"text-center"}>
                        <Button variant={"customPrimary"} onClick={() => {this.saveSettings()}}  size={"lg"}>사격 시작</Button>
                    </Col>
                </Row>

            </>
        )
    }
}

export default DuelingConfigure;